import FeeAnswersViewModel from "./FeeAnswersViewModel";


export default class EnrolmentFormMultiCourseViewModel {
    offeringId: string | undefined = undefined;
    academicYearId: string | undefined = undefined;
    enrolmentType: string | undefined = undefined;

    code: string | undefined = undefined;
    selected: boolean = false;

    /// fees
    progDate: Date | undefined = new Date();
    progTitle: string | undefined = undefined;
    courseLevel: string | undefined = undefined;
    courseLevelDesc: string | undefined = undefined;
    courseFeesMax: number | undefined = undefined;
    examFeesMax: number | undefined = undefined;
    resultSetId: number | undefined = undefined;

    feeAnswers: FeeAnswersViewModel = new FeeAnswersViewModel();

    showExamsCost: boolean = false;

} 